import {
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import CodeVelocity from './CodeVelocity';
import Contributors from './Contributors';
import SprintVelocity from './SprintVelocity';
import TeamCollaboration from './TeamCollaboration';
import WorkingAgreement from './WorkingAgreement';
import TeamMetrics from './TeamMetrics';
import { getTabList, getTabs } from '../../helpers/team-details.utils';
import TeamStats from './TeamStats';
import InProgress from './InProgress';
import { ISelect, PeriodType } from '@devd-client/devd/components';
import { useAuth } from '@devd-client/devd/auth';
import { TeamGoals } from './TeamGoals';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { UserRole } from '@devd-client/api';
interface RightContentProps {
  selectedTab: string;
  setSelectedTab: (selectedTab: string) => void;
  selected: PeriodType;
  selectedTeam: ISelect;
  setSelectedTeam: (selectedTeam: ISelect) => void;
}

const RightContent: React.FC<RightContentProps> = ({
  selectedTab,
  setSelectedTab,
  selected,
  selectedTeam,
  setSelectedTeam,
}) => {
  const [appState] = useAuth();
  const { pathname } = useLocation();
  const tabList = getTabList(appState?.user?.dto?.role as string);
  const tabs = getTabs(appState?.user?.dto?.role as string);

  const handleTabChange = (index: number) => {
    if (Number.isInteger(index) && Object.values(tabs).includes(index)) {
      setSelectedTab(
        Object.keys(tabs).find((key) => tabs[key] === index) ?? ''
      );
    }

    return null;
  };

  useEffect(() => {
    setSelectedTeam({
      label: decodeURIComponent(pathname.split('/')[2]),
      value: decodeURIComponent(pathname.split('/')[2]),
    });
  }, []);

  return (
    <Stack spacing={6}>
      <Stack spacing={3} width="100%">
        <Tabs width="100%" index={tabs[selectedTab]} onChange={handleTabChange}>
          <TabList>
            {tabList.map((tab: string) => (
              <Tab
                key={tab}
                color="text.secondary3"
                _selected={{
                  color: 'primary',
                  borderBottom: '2px solid',
                  borderColor: 'primary',
                }}
                w="105px"
                fontSize={'13px'}
                fontWeight={'semibold'}
                mr={'8px'}
              >
                {tab}
              </Tab>
            ))}
          </TabList>

          <TabPanels>
            <TabPanel px={0}>
              {selectedTab === 'teamStats' && <TeamStats selected={selected} />}
            </TabPanel>
            <TabPanel px={0}>
              {selectedTab === 'teamMetrics' && (
                <TeamMetrics selected={selected} />
              )}
            </TabPanel>
            <TabPanel px={0}>
              {selectedTab === 'teamGoals' && <TeamGoals />}
            </TabPanel>
            {appState?.user?.dto?.role !== UserRole.EMPLOYEE && (
              <TabPanel px={0}>
                {selectedTab === 'contributors' && (
                  <Contributors
                    selected={selected}
                    selectedTeam={selectedTeam}
                  />
                )}
              </TabPanel>
            )}
            <TabPanel px={0}>
              {selectedTab === 'repositories' && (
                <CodeVelocity selected={selected} />
              )}
            </TabPanel>

            <TabPanel px={0}>
              {selectedTab === 'sprint' && <SprintVelocity />}
            </TabPanel>

            <TabPanel px={0}>
              {selectedTab === 'team' && (
                <TeamCollaboration selected={selected} />
              )}
            </TabPanel>

            <TabPanel px={0}>
              {selectedTab === 'workingAgreement' && (
                <WorkingAgreement selected={selected} />
              )}
            </TabPanel>
            <TabPanel px={0}>
              {selectedTab === 'inProgress' && (
                <InProgress selected={selected} />
              )}
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Stack>
    </Stack>
  );
};
export default RightContent;
